<template>
    <div class="fixed w-full h-full inset-0 bg-black/35 flex justify-center items-center z-50 px-5">
        <div
            class="relative lg:w-1/5 w-5/6 h-fit flex flex-col justify-center p-5 items-center space-y-5 bg-white   rounded-xl">
            <div class="w-full flex justify-center items-center">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.75"
                    stroke="currentColor" class="w-12 text-white bg-primary p-1 rounded-full">
                    <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                </svg>
            </div>

            <div class="w-2/3 text-center text-gray-600">
                {{ $t('admin_edit.successMessage') }}
            </div>
        </div>
    </div>
</template>

<script setup>

</script>